import axios from 'axios';
import { fixDate } from './dates';

export default {
  init: function () {
    axios.interceptors.request.use((config) => {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      if (!response.data) {
        return response;
      }

      function modifyDates(obj) {
        if (Array.isArray(obj)) {
          // If it's an array, process each element
          obj.forEach(item => modifyDates(item));
        } else if (typeof obj === 'object' && obj !== null) {
          // If it's an object, iterate through its keys
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              if (key.toLowerCase().includes('date') && obj[key] !== null && obj[key] !== undefined) {
                // If the key contains 'date' and has a value, modify its value
                obj[key] = fixDate(obj[key]);
              }
              // Recursively call modifyDates if the value is an object or an array
              if (typeof obj[key] === 'object') {
                modifyDates(obj[key]);
              }
            }
          }
        }
      }


      modifyDates(response.data);



      return response;
    }, ((error) => {
      console.error('Response error intercepted:', error.message);
      return Promise.reject(error); // reject the promise with the error
    }));

 

  }
}
